export default __webpack_public_path__ + "static/emi-c8e067b3a994b5612c80043caa856a3d.png";